<template>
    <div>
        <div class="title">
            <i class="material-icons success">check_circle</i>
            <span>發生錯誤</span>
        </div>
        
        <div class="dialog-second-content">
            <p>必須選擇一項科目！</p>
        </div>

        <a @click="confirm">我知道了</a>
    </div>
</template>
<script>
export default {
    name:"modalTest",
    props:{
        params:{
        }
    },
    data(){
        return{
            info:this.params.firstInput,            
        }
    },
    created(){
    },
    methods:{
        confirm(){
            this.$emit("close",this.info);            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling-apply/PopErrorChoose.vue